export const PHASE_LAYOUT_PREVIEW_ROUTE = "av-fase-layout-preview";

/** Shared standard layout. Retain the internal name for the classic fallback. */
export function phaseLayoutPreviewEnabled(store, route) {
    return ["av-fase", "av-operatore", PHASE_LAYOUT_PREVIEW_ROUTE].includes(route?.name)
        && store?.getters?.isLoggedIn === true && Boolean(store.getters.token);
}
